import { VueMaskDirective } from "v-mask";
import Vue from 'vue';

Vue.directive("mask", VueMaskDirective);
